<template>
  <div>
    <label class="font-bold mb-4 block " :for="$attrs.id">
      <slot name="header" />
    </label>
    <slot />
    <div id="config-options" class="flex flex-wrap flex-col">
      <div v-for="(option, index) in $attrs['data-options']" :key="option" class>
        <DrButton
          class="w-full sm:w-1/2 btn-outline btn-blue rounded-l-none rounded-r-none border-b-0"
          :class="{
            'btn-selected': value === option,
            'btn-deselected': option !== value,
            'rounded-t': index === 0,
            'rounded-b border-b': index === $attrs['data-options'].length - 1,
          }"
          @click.prevent="selectChoice(option)"
        >
          {{ format(option) }}
        </DrButton>
      </div>
    </div>
  </div>
</template>

<script>
// import Component from ‘@/components/path/component.vue’

export default {
  // computed: {},
  // watchers: {}.
  // filters: {},
  // components: {},
  props: {
    value: {
      type: [Boolean, String, Number],
      default: '',
    },
    filter: {
      type: [String],
      default: '',
    },
  },
  //   }
  //   data () {
  //     return { }
  //   },
  methods: {
    selectChoice (option) {
      this.$emit('input', option)
    },
    format (value) {
      if (this.filter !== '') {
        return this.$options.filters[this.filter](value)
      }
      return value
    },
  },
}
</script>

<style>
.btn-selected {
  @apply text-white bg-blue-500 !important;
}
</style>
